module.exports = __webpack_public_path__ + "img/meter-ok.6639d206.svg";